// extracted by mini-css-extract-plugin
export default {"skill-box-grouping":"SkillBoxGroup_skill-box-grouping__d3s9d","skill-boxes":"SkillBoxGroup_skill-boxes__67nu1"};